import cx from 'classnames'
import React, { useEffect } from 'react'

import { post } from '@js/common/api'
import { getUrl } from '@js/common/getUrlByDomain'
import { UA } from '@js/common/UA'
import { supportsLocalStorage } from '@js/common/utils'

import { QuestionRadioButton } from '@f/applications/QuizApp/questions/QuestionRadio/QuestionRadioButton'
import ActionCardTemplate from '@f/elements/ActionCardTemplate'
import CTA from '@f/elements/CTA'
import Icon from '@f/elements/Icon'

const FinancingInterest = props => {
  useEffect(() => {
    props.actions.update_wtValue({ value: 'financing-consultation-interest' })
  }, [])
  const isConversionFunnel = Boolean(props.funnelVariant)

  const options = [
    {
      id: 'q10-o1',
      title: 'Ja',
      name: 'financing_consultation_interest',
      value: 'yes',
      _wtValue: true
    },
    {
      id: 'q10-o2',
      title: 'Nein',
      name: 'no_financing_consultation_interest',
      value: 'no',
      _wtValue: false
    }
  ]

  const renderOption = options.map(option => {
    let icon = ''
    let iconClassName = 'f-c-st-pri'
    if (option.name === 'financing_consultation_interest') {
      icon = 'check-circle-16px'
      iconClassName = 'f-c-st-suc400'
    }
    if (option.name === 'no_financing_consultation_interest') {
      icon = 'remove-16px'
      iconClassName = 'f-c-st-err'
    }

    return {
      value: option.value,
      label: option.title,
      CardIcon: () => (
        <Icon icon={icon} className={`[ f-icon-060 ${iconClassName} ]`} />
      )
    }
  })

  const handleSelection = option => {
    _wt({
      category: 'form',
      action: 'submit',
      location: 'modal-financing-consultation-interest',
      values: [
        {
          type: 'financing-consultation-interest',
          value: option.name
        }
      ],
      ...props.data.trackingInfo
    })

    post('profile', {
      financing_consultation_interest: option.value,
      email: props.data.user.email || UA.getLS().email
    })
      .then(response => {
        localStorage.setItem('wt_pid', response.public_id)
      })
      .finally(() => {
        const hasFinancingConsultationInterest = option.value === 'yes'
        if (!hasFinancingConsultationInterest) {
          window.location.href = `${getUrl('userAccount')()}uebersicht/`
        } else {
          if (supportsLocalStorage()) {
            localStorage.setItem('quiz', JSON.stringify(props.data.user))
          }
          const isIMSite = /immowelt|immonet/.test(window.__DOMAIN__)
          const redirectUrl = isIMSite
            ? '/bestellungen/finanzierungsberatung/'
            : '/finanzierungsberatung/#fk=house-wizard-item'
          window.location.href = redirectUrl
        }
      })
  }

  return (
    <div
      className={cx(
        'RequestWizard-form-wrapper',
        isConversionFunnel &&
          'RequestWizard-form-wrapper--HDP_conversion-funnel'
      )}>
      <div className='RequestWizard-top'>
        <div className='RequestWizard-heading'>
          <div className='[ f-t-tmedium f-c-fo-pri f-t-centre f-p-h-080:m ]'>
            Wünschen Sie eine kostenlose Finanzierungsberatung?
          </div>
        </div>

        <div className={`RequestWizard-content sq-question`}>
          <div className='[ f-overflow ]'>
            <div className='RequestWizard-options-wrapper'>
              {renderOption.map(option => (
                <QuestionRadioButton
                  key={option.value}
                  wtData={{
                    location: 'modal-financing-consultation-interest',
                    flow_information: props.data.trackingInfo.flow_information
                  }}
                  onClick={() => handleSelection(option)}>
                  <ActionCardTemplate {...option} />
                </QuestionRadioButton>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className='RequestWizard-bottom'>
        <p className='[ f-t-centre f-t-micro f-c-fo-neu200 f-m-v-010 f-p-h-080:m ]'>
          Mehr Informationen hinsichtlich der Kontaktaufnahme durch unsere
          Baufinanzierungspartner erhalten Sie in der{' '}
          <CTA
            type='text-primary'
            tag='a'
            href='/datenschutz/'
            target='_blank'
            className='internal'>
            Datenschutzerklärung
          </CTA>
          . Wir senden Ihnen anschließend eine Bestätigungsmail, die Ihnen die
          übersandten Daten zeigt. Ihre Anfrage ist jederzeit freiwillig,
          kostenlos und unverbindlich.
        </p>
      </div>
    </div>
  )
}

export default FinancingInterest
